import { createStore } from 'vuex'
import { getChainId,setChainId,getToken,removeToken } from '@/utils/auth'
import {MemberView,Loginout} from '@/api'
// import App from "@/api/app-ether"
import {connector,isShowModal,ConnectUI,checkedAddr} from '@/api/tonconnect'


export const store = createStore({
  state: {
    isConnect:false,
    Token:'',
    chain:'',
    address:"",
    member:'',
  },
  mutations: {
    set_Connect:(state, data)=>{
      state.isConnect = data
    },
    set_Token:(state, data)=>{
      state.Token = data
    },
    set_Chain:(state, data)=>{
      state.chain = data
    },
    set_address:(state, data)=>{
      state.address = data
    },
    set_member:(state, data)=>{
      state.member = data
    },
  },
  actions:{
    getAccountData({ commit }){
      const currentAccount = ConnectUI.account ;
      if(currentAccount){
        let addr = new TonWeb.utils.Address(currentAccount.address);
        let  address1 = addr.toString(true, true, false)
        commit('set_address', address1)
      }
      // const accountAddr = App.MetaMask.getCurrentAccount()
      // if(accountAddr&&getToken()){
      //   commit('set_address',accountAddr)
      // }
    },
    getClear({ commit }){
      commit('set_address','')
      commit('set_Token','')
      commit('set_Chain','')
      commit('set_member','')
      removeToken()
    },
    getReset({ commit }){
      Loginout().then(res=>{
        if (ConnectUI.connected) {
          ConnectUI.disconnect()
        }
        removeToken()
        localStorage.setItem('login',false)
        commit('set_address','')
        commit('set_Token','')
        commit('set_Chain','')
        commit('set_member','')
      })
    },
    getChain({ commit }){
      // App.MetaMask.getChain().then(res=>{
      //   setChainId(res.chainId)
      //   commit('set_Chain', res)
      //   // console.log(res)
      // })
    },
    getMemberView({ commit,dispatch}){
      return new Promise((resolve, reject) => {
        MemberView().then(response => {
          if(response){
              const data = response.Data
            //  if(!checkedAddr(data.member)){
            //     dispatch('getReset')
            //     setTimeout(()=>{
            //       location.reload()
            //     },500)
            //     return
            //  }else{
            //    commit('set_member', data.member)
            //    resolve(data)
            //  }
             commit('set_member', data.member)
               resolve(data)
          }
          }).catch(error => {
            reject(error)
          })
      })
    } ,
  },
  getters: {},
})
